import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getItems } from "src/common/toolkit/features/items";
import { PopularItemResponse } from "src/common/types/response/storeItems";
import useLocation from "./useLocation";
import { reportLog } from "../utils/logs";

const useQueryItems = (
  query: object
): [data: Array<PopularItemResponse>, loading: boolean] => {
  const [data, setData] = useState([]);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch<any>();
  const location = useLocation();

  useEffect(() => {
    if (location?.location?.coords) {
      setLoading(true);
      dispatch(
        getItems({
          ...query,
          latitude: location?.location?.coords?.latitude,
          longitude: location?.location?.coords?.longitude,
        })
      )
        .then((res) => {
          setLoading(false);
          if (res.error) {
            setError(true);
          } else {
            const data = res.payload as Array<PopularItemResponse>;
            setData(data);
          }
        })
        .catch((error) => {
          reportLog({
            error: error,
            location: "useQueryItems->getItems[44]",
            body: {
              query: { ...query },
              location: { ...(location?.location?.coords || {}) },
            },
          });
          setError(true);
          setLoading(false);
        });
    }
  }, [location?.location?.coords]);

  return [data, loading];
};

export default useQueryItems;
